/**
 * Where to go after signing in.
 *
 * Only a path on this origin is honoured. `?next=https://elsewhere.example` is
 * an open redirect — the sign-in screen would hand a member straight to a page
 * an attacker chose, having just watched them type a password. A protocol-
 * relative `//host` is the same attack with a shorter string, which is why the
 * second character is checked as well.
 */
export function safeNext(next: string | null): string {
  if (!next || !next.startsWith('/') || next.startsWith('//')) return '/';
  return next;
}
